module.exports = __webpack_public_path__ + "img/HZ-B5029.dadbf78c.jpg";